export * from './types'
export * from './client'

import { Client } from './client'
const defaultInst = new Client()
export default defaultInst
